import { Collection } from 'modules/core/lib/mobx-rest'

import SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

class SubscriptionAddons extends Collection<SubscriptionAddon> {
  get cacheKey(): string {
    return 'subscriptionAddons'
  }

  model() {
    return SubscriptionAddon
  }
}

const singleton: SubscriptionAddons = new SubscriptionAddons()

export default singleton
